// import { epicsList } from '../../constants/epics.index'

import axiosNew from '../../../../helpers/axios'

// GET TEST CASE LIST
export const apiGetTestCaseList = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/testcase/list`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// CREATE TEST CASE
export const createTestCase = (payload) => {
    return new Promise(async (resolve) => {
        try {
            let data = payload ?? {}
            const createEpicData = await axiosNew({
                url: 'testcase/add',
                method: 'post',
                data,
            })
            resolve({ data: createEpicData?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// DELETE TEST CASE
export const deleteTestCase = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const deleteEpic = await axiosNew({
                url: 'epics/delete/' + payload,
                method: 'delete',
            })
            resolve({ data: deleteEpic?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// UPDATE TEST CASE
export const updateTestCase = async (payload) => {
    return new Promise(async (resolve) => {
        try {
            const updatedEpic = await axiosNew({
                url: `/testcase/edit/${payload?.id}`,
                method: 'put',
                data: payload?.data,
            })
            resolve({ data: updatedEpic?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET EPICS LIST
export const apiGetTestCaseDetail = (id) => {
    return new Promise(async (resolve) => {
        try {
            const epicData = await axiosNew({
                url: `/testcase/detail/${id}`,
                method: 'get',
            })
            resolve({ data: epicData?.data?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET EPICS LIST
export const getEpicsListForTC = (params) => {
    return new Promise(async (resolve) => {
        try {
            const epicData = await axiosNew({
                url: `epics/list?${params}`,
                method: 'get',
            })
            resolve({ data: epicData?.data?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const getSprintListForTC = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const sprintData = await axiosNew({
                url: '/sprints/list',
                method: 'post',
                data: payload,
            })
            resolve({ data: sprintData?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

//Upload file t
export const getAttachmentPreUrl = async (payload) => {
    let data = payload ?? {}
    return new Promise(async (resolve) => {
        try {
            const res = await axiosNew({
                url: 'aws/upload-file',
                data,
            })
            resolve({ data: res.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

export const uploadAttachmentToAWS = async (file, url) => {
    try {
        const formData = new FormData()
        formData.append('file', file) // Assuming the file is passed as 'file'
        const response = await fetch(url, {
            method: 'PUT',
            headers: {
                'Content-Type': file.type,
            },
            body: file?.originFileObj ? file.originFileObj : file, // Directly sending the file as the body of the request
        })

        if (!response.ok) {
            throw new Error(`Failed to upload file: ${response.statusText}`)
        }
        return response
    } catch (error) {
        console.log('🚀 ~ uploadResumeS3Url ~ error:', error)
    }
}

// ADD TAG
export const apiAddTag = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/tags/add`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}

// GET TEST CASE LIST
export const apiGetTagList = (payload) => {
    return new Promise(async (resolve) => {
        try {
            const resp = await axiosNew({
                url: `/tags/list`,
                method: 'post',
                data: payload,
            })

            resolve({ data: resp?.data ?? {} })
        } catch (error) {
            resolve({ data: error?.response?.data ?? {} })
        }
    })
}
